// extracted by mini-css-extract-plugin
module.exports = {"informationMessage":"infoContainer_informationMessage__eY5A5","title":"infoContainer_title__38Wqh","content":"infoContainer_content__3DmTV"};